import { ProjectStatusEnum } from '@fasstech/oip-core/entities/enums';

// Statuses when project is editable (navigation + modifications).
export const EDITABLE_PROJECT_STATUSES = [
  ProjectStatusEnum.IN_PROGRESS,
  ProjectStatusEnum.EDITING
];

// Terminal blocking statuses: no more next/prev action nor modification.
export const BLOCKED_PROJECT_STATUSES = [
  ProjectStatusEnum.SUBSCRIPTION_FAILED,
  'PURGED'
];

// On resume the user is sent back to the recap and can no longer navigate
export const SIGNATURE_FLOW_STATUSES = [
  ProjectStatusEnum.SENT_FOR_SIGNATURE,
  ProjectStatusEnum.SIGNED,
  ProjectStatusEnum.SIGNATURE_CANCELLED,
  ProjectStatusEnum.SIGNATURE_EXPIRED,
  ProjectStatusEnum.SIGNATURE_REFUSED
];

export const isProjectEditable = (status) =>
  EDITABLE_PROJECT_STATUSES.includes(status);

export const isProjectBlocked = (status) =>
  BLOCKED_PROJECT_STATUSES.includes(status);

export const isProjectInSignatureFlow = (status) =>
  SIGNATURE_FLOW_STATUSES.includes(status);
